<template>
	<pre v-html="$t('terms.legal_indication1')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication1',
};
</script>

<style scoped></style>
